// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nbwrap .mc-notification-badge {
  background-color: var(--ion-color-primary);
  border-radius: 50%;
  display: block;
  border-radius: 50%;
  display: block;
  border: 2px solid var(--ion-toolbar-background, var(--mc-surface-0));
  min-width: 10px;
  min-height: 10px;
}
.nbwrap .mc-notification-badge.bubble {
  width: 10px;
  height: 10px;
}

ion-note {
  position: relative;
  top: 2px;
}

ion-badge {
  background-color: var(--mc-color-light-red) !important;
  font-size: 11px;
  font-weight: 400;
  line-height: 11px;
  padding: 2px 4px;
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/notification-badge/notification-badge.component.scss"],"names":[],"mappings":"AACC;EACC,0CAAA;EAEA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,oEAAA;EACA,eAAA;EACA,gBAAA;AADF;AAEE;EACC,WAAA;EACA,YAAA;AAAH;;AAIA;EACC,kBAAA;EACA,QAAA;AADD;;AAIA;EACC,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AADD","sourcesContent":[".nbwrap {\r\n\t.mc-notification-badge {\r\n\t\tbackground-color: var(--ion-color-primary);\r\n\t\t\r\n\t\tborder-radius: 50%;\r\n\t\tdisplay: block;\r\n\t\tborder-radius: 50%;\r\n\t\tdisplay: block;\r\n\t\tborder: 2px solid var(--ion-toolbar-background, var(--mc-surface-0));\r\n\t\tmin-width: 10px;\r\n\t\tmin-height: 10px;\r\n\t\t&.bubble {\r\n\t\t\twidth: 10px;\r\n\t\t\theight: 10px;\r\n\t\t}\r\n\t}\r\n}\r\nion-note {\r\n\tposition: relative;\r\n\ttop: 2px;\r\n}\r\n\r\nion-badge {\r\n\tbackground-color:  var(--mc-color-light-red) !important;\r\n\tfont-size: 11px;\r\n\tfont-weight: 400;\r\n\tline-height: 11px;\r\n\tpadding: 2px 4px;\r\n\tborder-radius: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
